import j from "./index.es206.js";
import P from "./index.es207.js";
import z from "./index.es208.js";
import H from "./index.es209.js";
import W from "./index.es210.js";
import G from "./index.es211.js";
import D from "./index.es212.js";
import E from "./index.es213.js";
import J from "./index.es214.js";
import M from "./index.es215.js";
import U from "./index.es216.js";
import Z from "./index.es217.js";
import { generateSheets as q } from "./index.es218.js";
var B = ["fileName"];
function v(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = K(e)) || t) {
    r && (e = r);
    var o = 0;
    return function() {
      return o >= e.length ? { done: !0 } : { done: !1, value: e[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function K(e, t) {
  if (e) {
    if (typeof e == "string") return w(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? w(e, t) : void 0;
  }
}
function w(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, o = Array(t); r < t; r++) o[r] = e[r];
  return o;
}
function Q(e, t) {
  if (e == null) return {};
  var r, o, a = V(e, t);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);
    for (o = 0; o < l.length; o++) r = l[o], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (a[r] = e[r]);
  }
  return a;
}
function V(e, t) {
  if (e == null) return {};
  var r = {};
  for (var o in e) if ({}.hasOwnProperty.call(e, o)) {
    if (t.indexOf(o) !== -1) continue;
    r[o] = e[o];
  }
  return r;
}
function ue(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.fileName, o = Q(t, B);
  return Y(e, o).then(function(a) {
    return r ? P.saveAs(a, r) : a;
  });
}
function Y(e, t) {
  var r = t.sheet, o = t.sheets, a = t.schema, l = t.columns, h = t.images, b = t.headerStyle, k = t.getHeaderStyle, x = t.fontFamily, C = t.fontSize, F = t.orientation, g = t.stickyRowsCount, y = t.stickyColumnsCount, A = t.showGridLines, I = t.rightToLeft, X = t.dateFormat, m = new j(), u = q({
    data: e,
    sheetName: r,
    sheetNames: o,
    schema: a,
    columns: l,
    images: h,
    headerStyle: b,
    getHeaderStyle: k,
    fontFamily: x,
    fontSize: C,
    orientation: F,
    stickyRowsCount: g,
    stickyColumnsCount: y,
    showGridLines: A,
    rightToLeft: I,
    dateFormat: X
  }), f = u.sheets, L = u.getSharedStrings, O = u.getStyles;
  m.file("_rels/.rels", G), m.file("[Content_Types].xml", D({
    sheets: f,
    images: h
  }));
  var n = m.folder("xl");
  n.file("_rels/workbook.xml.rels", W({
    sheets: f
  })), n.file("workbook.xml", H({
    sheets: f,
    stickyRowsCount: g,
    stickyColumnsCount: y
  })), n.file("styles.xml", Z(O())), n.file("sharedStrings.xml", U(L()));
  for (var T = v(f), d; !(d = T()).done; ) {
    var c = d.value, i = c.id, N = c.data, s = c.images;
    if (n.file("worksheets/sheet".concat(i, ".xml"), N), n.file("worksheets/_rels/sheet".concat(i, ".xml.rels"), M({
      id: i,
      images: s
    })), s) {
      n.file("drawings/drawing".concat(i, ".xml"), E({
        images: s
      })), n.file("drawings/_rels/drawing".concat(i, ".xml.rels"), J({
        images: s,
        sheetId: i
      }));
      for (var R = v(s), p; !(p = R()).done; ) {
        var S = p.value;
        n.file("media/".concat(z(S, {
          sheetId: i,
          sheetImages: s
        })), S.content);
      }
    }
  }
  return m.generateAsync({
    type: "blob",
    mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    compression: "deflate"
  });
}
export {
  ue as default
};
//# sourceMappingURL=index.es76.js.map
